import { BackButton } from '@features/regional-overview/components/back-button/back-button.component';
import { COLOR_OPTIONS } from 'config/style';
import STTypo from 'core/shared/typo/typo.component';
import { TypeOptions } from 'core/shared/typo/typo.models';
import styles from './modal-back-header.module.css';

interface ModalBackHeaderProps {
  title: string;
  onBack: () => void;
  backAriaLabel: string;
  backButtonTestId?: string;
}

export const ModalBackHeader = ({ title, onBack, backAriaLabel, backButtonTestId }: ModalBackHeaderProps) => (
  <div className={styles.header}>
    <span className={styles.backButtonWrapper}>
      <BackButton aria-label={backAriaLabel} onClick={onBack} data-testid={backButtonTestId} />
    </span>
    <STTypo type={TypeOptions.H5} color={COLOR_OPTIONS.NEUTRAL_100} fontFamily='Noto Sans' fontWeight={600}>
      {title}
    </STTypo>
  </div>
);
